/**
 * CategoryFilterBanner — sits above the dashboard charts when the
 * user has clicked a category in the breakdown below. Shows the
 * filter label + element count + a clear button. Surfaces fetch
 * errors and truncation warnings.
 *
 * Extracted from ResultsPage.js on Feb 26, 2026.
 */

export function CategoryFilterBanner({
  selectedCategory,
  selectedCategoryLabel,
  detailsLoading,
  detailsError,
  detailsTruncated,
  chartData,
  onClear,
}) {
  if (!selectedCategory) return null;
  return (
    <div
      className="flex flex-wrap items-center gap-2 mb-3 p-3 rounded-md border border-[hsl(var(--accent))]/40 bg-[hsl(var(--accent))]/5"
      data-testid="category-filter-banner"
    >
      <span className="text-xs uppercase tracking-wider text-[hsl(var(--accent))] font-semibold">
        Filtered by
      </span>
      <span className="text-sm font-medium text-foreground" data-testid="category-filter-label">
        {selectedCategoryLabel}
      </span>
      <span
        className="text-[11px] text-muted-foreground ml-auto"
        data-testid="category-filter-counts"
      >
        {detailsLoading
          ? 'Loading category details…'
          : chartData.length > 0
          ? `${chartData.length} element${chartData.length === 1 ? '' : 's'} touched by this category`
          : 'No elements were checked for this category.'}
        {detailsTruncated && ' (showing first 10,000 rule rows)'}
      </span>
      <button
        type="button"
        onClick={onClear}
        className="text-xs px-2 py-1 rounded border border-[hsl(var(--accent))]/40 hover:bg-[hsl(var(--accent))]/10 text-[hsl(var(--accent))] font-medium"
        data-testid="clear-category-filter-btn"
      >
        ✕ Clear filter
      </button>
      {detailsError && (
        <p
          className="basis-full text-xs text-[hsl(var(--destructive))]"
          data-testid="category-filter-error"
        >
          {detailsError}
        </p>
      )}
    </div>
  );
}
